import React from 'react';
import { Link, Navigate, useParams, useSearchParams } from 'react-router-dom';
import { getTeamMemberBySlug, routes, teamTabFromParam, teams, teamsHref } from '../../models/content';

const TEAM_BADGE_LABELS = {
  'Leadership Teams': 'Leadership',
  'Investment Teams': 'Investment',
  'Operations Team': 'Operations',
};

function splitDisplayName(name) {
  const parts = name.trim().split(/\s+/);
  if (parts.length <= 1) return { first: name, last: '' };
  const last = parts.pop();
  return { first: parts.join(' '), last };
}

export default function V2TeamMemberDetail() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const result = getTeamMemberBySlug(slug);

  if (!result) {
    return <Navigate to={routes.home} replace />;
  }

  const { member, category } = result;
  const tabParam = searchParams.get('tab');
  const backTab = tabParam ? teamTabFromParam(tabParam) : category;
  const { first, last } = splitDisplayName(member.name);
  const badge = TEAM_BADGE_LABELS[backTab] ?? TEAM_BADGE_LABELS[teams.tabs[0].key];

  return (
    <main>
      <section className="page-hero">
        <div className="wrap">
          <span className="v2-badge">
            <span className="dot" />
            {badge}
          </span>
          <h1>
            {first}
            {last ? (
              <>
                {' '}
                <span className="it">{last}</span>
              </>
            ) : null}
          </h1>
        </div>
      </section>

      <section>
        <div className="wrap">
          <article className="team-detail">
            <div
              className="portrait"
              style={{
                backgroundImage: member.image ? `url("${member.image}")` : undefined,
                backgroundColor: member.image ? undefined : 'var(--p100)',
              }}
            />
            <div className="body">
              <h2>{member.name}</h2>
              <div className="role">{member.role}</div>
              {member.detailParagraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
              <Link to={teamsHref(backTab)} className="btn btn-ghost back-btn">
                ← Back to Teams
              </Link>
            </div>
          </article>
        </div>
      </section>
    </main>
  );
}
